// lib/orderTracking/steps.ts
// PURA: del snapshot a los hitos de la línea de tiempo. La UI solo pinta.
import type { TrackingSnapshot } from "./types"

export type StepKey = "recibido" | "en_cocina" | "listo" | "en_camino" | "entregado" | "cancelado"
export type TimelineStep = { key: StepKey; status: "done" | "current" | "todo"; at: string | null }

export function buildSteps(s: TrackingSnapshot): TimelineStep[] {
  if (s.state === "cancelado") {
    return [
      { key: "recibido", status: "done", at: s.steps.receivedAt },
      { key: "cancelado", status: "current", at: null },
    ]
  }
  const keys: StepKey[] = s.isDelivery
    ? ["recibido", "en_cocina", "listo", "en_camino", "entregado"]
    : ["recibido", "en_cocina", "listo", "entregado"]
  const at: Record<StepKey, string | null> = {
    recibido: s.steps.receivedAt,
    en_cocina: s.steps.inKitchenAt,
    listo: s.steps.readyAt,
    en_camino: s.delivery?.pickedUpAt ?? s.delivery?.dispatchedAt ?? null,
    entregado: s.steps.doneAt,
    cancelado: null,
  }
  // "recibido" nunca es el estado actual (enmienda 1), así que currentIdx >= 1.
  const currentIdx = keys.indexOf(s.state as StepKey)
  return keys.map((key, i) => ({
    key,
    status: s.state === "entregado" || i < currentIdx ? "done" : i === currentIdx ? "current" : "todo",
    at: i <= currentIdx ? at[key] : null,
  }))
}
